export const compactFormHintsKey = Symbol('compactFormHints');
